import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../utils/services/api.service';
import { FLIGHT_PROVIDERS, HOTEL_PROVIDERS, PROVIDER_TYPES, PROVIDER_FIELDS, PACKAGE_PROVIDERS, passwordValidator, CHANNEL_MANAGER_PROVIDERS } from '../../../utils/constants/constants';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-agency-add',
  templateUrl: './agency-add.component.html',
  styleUrls: ['./agency-add.component.css']
})

export class AgencyAddComponent implements OnInit {

  public signUpForm: FormGroup;
  public organizationParameterForm: FormGroup;
  public addressForm: FormGroup;
  public formList: Array<FormGroup>;
  public formIndex = 0;
  public isDone = false;
  public providers = FLIGHT_PROVIDERS;
  public selectedProvider;
  public types = PROVIDER_TYPES;
  public selectedType;
  public currencies = ['TRY', 'EUR', 'USD'];
  validationFields = {
    'tourvisio': ['type', 'serviceURL'],
    'epower': ['type', 'provider', 'username', 'password', 'serviceURL', 'serviceKey'],
    'thy': ['type', 'provider', 'username', 'password', 'serviceURL'],
    'thyRest': ['type', 'provider', 'username', 'password', 'serviceURL'],
    'pegasus': ['type', 'provider', 'username', 'password', 'serviceURL', 'TRY'],
    'bizipackage': ['type', 'provider', 'baseURL'],
    'bizihotel': ['type', 'provider', 'baseURL'],
    'extrahotel': ['type', 'provider', 'baseURL'],
    'paximum': ['type', 'provider', 'baseURL', 'appToken']
  }

  constructor(private apiService: ApiService,
    private router: Router,
    private notificationsService: NotificationsService) {
  }

  ngOnInit() {
    this.formList = [];
    this.signUpForm = new FormGroup({
      'agencyName': new FormControl(null, [Validators.required, Validators.minLength(3)]),
      'legalEntity': new FormControl(null),
      'firstName': new FormControl(null, [Validators.required, Validators.minLength(3)]),
      'lastName': new FormControl(null, [Validators.required, Validators.minLength(2)]),
      'email': new FormControl(null, [Validators.required, Validators.email]),
      'password': new FormControl(null, [Validators.required, Validators.minLength(8), passwordValidator()]),
      'passwordControl': new FormControl(null, [Validators.required, Validators.minLength(8), passwordValidator()]),
      'language': new FormControl('tr', [Validators.required]),
      'phoneCode': new FormControl(null, [Validators.required]),
      'phoneType': new FormControl(null, [Validators.required]),
      'phoneNumber': new FormControl(null, [Validators.required]),
      'segmentType': new FormControl('FULL', [Validators.required]),
    });
    this.organizationParameterForm = new FormGroup({
      'type': new FormControl(null),
      'provider': new FormControl(null),
      'username': new FormControl(null),
      'password': new FormControl(null),
      'serviceURL': new FormControl(null),
      'serviceKey': new FormControl(null),
      'TRY': new FormControl(null),
      'USD': new FormControl(null),
      'EUR': new FormControl(null),
      'company': new FormControl(null),
      'baseURL': new FormControl(null),
      'ShowUseCompanyPrice': new FormControl(null),
      'appToken': new FormControl(null)
    });
    this.addressForm = new FormGroup({
      'address1': new FormControl(null, Validators.required),
      'address2': new FormControl(null),
      'billingAccountingNumber': new FormControl(null),
      'city': new FormControl(null, [Validators.required]),
      'countryId': new FormControl('TR', [Validators.required]),
      'faxCode': new FormControl(null),
      'faxNumber': new FormControl(null),
      'name': new FormControl(null, [Validators.required]),
      'onlineTradeRegisterNo': new FormControl(null),
      'phoneCode': new FormControl(null, [Validators.required]),
      'phoneNumber': new FormControl(null, [Validators.required]),
      'street': new FormControl(null, [Validators.required]),
      'taxAdministrationNo': new FormControl(null, [Validators.required]),
      'taxNo': new FormControl(null, [Validators.required]),
      'tradeRegisterNo': new FormControl(null),
      'type': new FormControl(null),
      'zipcode': new FormControl(null, [Validators.required]),
    });
    this.formList.push(this.signUpForm);
    this.formList.push(this.organizationParameterForm);
    this.formList.push(this.addressForm);
  }
  onNextClicked() {
    if (this.formIndex == 1 && this.organizationParameterForm.invalid) {
      this.notificationsService.warn('Lütfen gerekli alanları doldurunuz!');
      return;
    }
    if (this.formIndex >= this.formList.length - 1) {
      this.formIndex = this.formList.length - 1;
      this.isDone = true;
    } else {
      this.formIndex++;
      this.isDone = false;
    }
  }

  onPreviousClicked() {
    this.isDone = false;
    if (this.formIndex <= 0) {
      this.formIndex = 0;
    } else {
      this.formIndex--;
    }
  }

  saveAgency() {
    let postData = {
      "user": {
        "firstName": this.signUpForm.controls.firstName.value,
        "lastName": this.signUpForm.controls.lastName.value,
        "password": this.signUpForm.controls.password.value,
        "username": this.signUpForm.controls.email.value
      },
      "organization": {
        "name": this.signUpForm.controls.agencyName.value,
        "legalEntity": this.signUpForm.controls.legalEntity.value,
        "twoFactorType": false,
        "segment":this.signUpForm.controls.segmentType.value,
      },
      'phone': {
        type: this.signUpForm.value.phoneType,
        phoneCode: this.signUpForm.value.phoneCode,
        number: this.signUpForm.value.phoneNumber,
        isPrimary: true
      },
      'profile': {
        language: this.signUpForm.controls.language.value
      },
      'address':{
        address1: this.addressForm.value.address1,
        address2: this.addressForm.value.address2,
        billingAccountingNumber: this.addressForm.value.billingAccountingNumber,
        city: this.addressForm.value.city,
        countryId:this.addressForm.value.countryId,
        faxCode: this.addressForm.value.faxCode,
        faxNumber: this.addressForm.value.faxNumber,
        name: this.addressForm.value.name,
        onlineTradeRegisterNo: this.addressForm.value.onlineTradeRegisterNo,
        phoneCode:this.addressForm.value.phoneCode,
        phoneNumber: this.addressForm.value.phoneNumber,
        street: this.addressForm.value.street,
        taxAdministrationNo: this.addressForm.value.taxAdministrationNo,
        taxNo:this.addressForm.value.taxNo,
        tradeRegisterNo: this.addressForm.value.tradeRegisterNo,
        type: 'Main',
        zipcode:this.addressForm.value.zipcode,
      }
    }
    if (!this.organizationParameterForm.valid || !this.organizationParameterForm.value.provider) {
      postData['parameters'] = [];
    } else {
      switch (this.organizationParameterForm.value.provider) {
        case "tourvisio":
          let tourvisioParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "serviceURL",
              "value": this.organizationParameterForm.controls.serviceURL.value
            }
          ]
          postData['parameters'] = tourvisioParameters;
          break;
        case 'thy':
          let thyParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "password",
              "value": this.organizationParameterForm.controls.password.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "serviceURL",
              "value": this.organizationParameterForm.controls.serviceURL.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "username",
              "value": this.organizationParameterForm.controls.username.value
            },
          ]
          postData['parameters'] = thyParameters;

          break;
        case 'thyRest':
          let thyRestParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "password",
              "value": this.organizationParameterForm.controls.password.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "serviceURL",
              "value": this.organizationParameterForm.controls.serviceURL.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "username",
              "value": this.organizationParameterForm.controls.username.value
            },
          ]
          postData['parameters'] = thyRestParameters;

          break;
        case "epower":
          let epowerParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "password",
              "value": this.organizationParameterForm.controls.password.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "serviceURL",
              "value": this.organizationParameterForm.controls.serviceURL.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "serviceKey",
              "value": this.organizationParameterForm.controls.serviceKey.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "username",
              "value": this.organizationParameterForm.controls.username.value
            },
          ]
          postData['parameters'] = epowerParameters;
          break;
        case "pegasus":
          let pegasusParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "password",
              "value": this.organizationParameterForm.controls.password.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "serviceURL",
              "value": this.organizationParameterForm.controls.serviceURL.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "username",
              "value": this.organizationParameterForm.controls.username.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "TRY",
              "value": this.organizationParameterForm.controls.TRY.value
            }
          ]

          if (this.organizationParameterForm.controls.USD.value) {
            postData['parameters'].push({
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "USD",
              "value": this.organizationParameterForm.controls.USD.value
            })
          }
          if (this.organizationParameterForm.controls.EUR.value) {
            postData['parameters'].push({
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "EUR",
              "value": this.organizationParameterForm.controls.EUR.value
            })
          }
          postData['parameters'] = pegasusParameters;
          //agency['flightProviderShowUseCompanyPrice'] = this.organizationParameterForm.controls.ShowUseCompanyPrice.value;
          break;
        case 'bizihotel':
          let biziHotelParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "baseURL",
              "value": this.organizationParameterForm.controls.baseURL.value
            }]
          postData['parameters'] = biziHotelParameters;
          break;
        case 'extrahotel':
          let extraHotelParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "baseURL",
              "value": this.organizationParameterForm.controls.baseURL.value
            }]
          postData['parameters'] = extraHotelParameters;
          break;
        case "bizipackage":
          let biziPackageParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "baseURL",
              "value": this.organizationParameterForm.controls.baseURL.value
            },
          ]
          postData['parameters'] = biziPackageParameters;
          break;
        case "paximum":
          let paximumParameters = [
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "baseURL",
              "value": this.organizationParameterForm.controls.baseURL.value
            },
            {
              "context": this.organizationParameterForm.controls.provider.value,
              "type": this.organizationParameterForm.controls.type.value,
              "key": "appToken",
              "value": this.organizationParameterForm.controls.appToken.value
            }
          ]
          postData['parameters'] = paximumParameters;
          break;
      }
    }
    this.apiService.createAgency(postData).subscribe(
      response => {
        this.notificationsService.success('Success', 'Agency is created');
        this.router.navigate(['admin/agencies']);
      }, error => {
        this.notificationsService.error('Error', 'Error occured');
      }
    );
  }

  setType() {
    this.selectedType = this.organizationParameterForm.value.type;
    this.selectedProvider = null;
    this.setNullValidators();
    if (this.selectedType === 'FlightProvider') {
      this.providers = FLIGHT_PROVIDERS;
    } else if (this.selectedType === 'HotelProvider') {
      this.providers = HOTEL_PROVIDERS;
    } else if (this.selectedType === 'PackageProvider') {
      this.providers = PACKAGE_PROVIDERS;
    } else if (this.selectedType === 'ChannelManagerProvider') {
      this.providers = CHANNEL_MANAGER_PROVIDERS;
    }
  }

  setForm() {
    if (!this.organizationParameterForm.value.provider) {
      this.setNullValidators();
      return;
    }
    this.selectedProvider = this.organizationParameterForm.value.provider;
    if (this.selectedProvider) {
      this.setNullValidators();
      this.validationFields[this.selectedProvider].forEach(field => {
        this.organizationParameterForm.controls[field].setValidators(Validators.required);
        if (!this.organizationParameterForm.controls[field].value)
          this.organizationParameterForm.controls[field].setErrors({ required: true });
      })
    } else {
      this.setNullValidators();
    }

  }
  setNullValidators() {
    this.organizationParameterForm.controls['type'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['provider'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['username'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['username'].setErrors(null);
    this.organizationParameterForm.controls['type'].setErrors(null);
    this.organizationParameterForm.controls['provider'].setErrors(null);
    this.organizationParameterForm.controls['password'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['password'].setErrors(null);
    this.organizationParameterForm.controls['serviceURL'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['serviceURL'].setErrors(null);
    this.organizationParameterForm.controls['serviceKey'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['serviceKey'].setErrors(null);
    this.organizationParameterForm.controls['baseURL'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['baseURL'].setErrors(null);
    this.organizationParameterForm.controls['TRY'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['TRY'].setErrors(null);
    this.organizationParameterForm.controls['appToken'].setValidators(Validators.nullValidator);
    this.organizationParameterForm.controls['appToken'].setErrors(null);
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/agency-add/agency-add.component.ts